/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Check = createReactComponent("check", "Check", [["path", { "d": "m6 13.626 1.606 1.722c.886.95 1.329 1.424 1.825 1.574.436.131.9.096 1.315-.1.473-.224.852-.761 1.612-1.836L18 7", "key": "svg-0" }]]);

export { Check as default };
//# sourceMappingURL=Check.js.map
